const HomePage = () => {
    return ( 
        <main className="homepage">
            <aside className="left-side">
                <h4>
                    So, you want to travel to
                </h4>
                <h1>
                    Space 
                </h1>
                <h4 style={{textTransform: "capitalize"}}>
                    Let’s face it; if you want 
                    to go to space, you might as well genuinely go to outer space and not 
                    hover kind of on the edge of it. Well sit back, and relax 
                    because we’ll give you a truly out of this world experience!
                </h4>
            </aside>
            <aside className="right-side">
                <h1>Explore</h1>
            </aside>
        </main>
     );
}
 
export default HomePage;